import { render, staticRenderFns } from "./StockProductLayout.vue?vue&type=template&id=c3021d62&scoped=true&"
import script from "./StockProductLayout.vue?vue&type=script&lang=js&"
export * from "./StockProductLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3021d62",
  null
  
)

export default component.exports